import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chat-messaging",
  "use": "chat-messaging-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"chat-messaging\"><path fill-rule=\"evenodd\" d=\"M4 2c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4Zm14 7v2H6V9h12ZM6 14v-2h8v2H6Zm0-6V6h12v2H6Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol